import type { FC } from "react";

import {
    SuccessImageWrapper,
    SuccessSubtitle,
    SuccessTitle,
} from "app/pages/sales-intelligence/common-components/ContactUsModal/modalContent/styles";
import SuccessImage from "app/pages/sales-intelligence/common-components/ContactUsModal/modalContent/SuccessImage";

interface SuccessHookBlockProps {
    title: string;
    subTitle: string;
}

export const SuccessHookBlock: FC<SuccessHookBlockProps> = ({ title, subTitle }) => {
    return (
        <>
            <SuccessImageWrapper>
                <SuccessImage />
            </SuccessImageWrapper>
            <SuccessTitle>{title}</SuccessTitle>
            <SuccessSubtitle>{subTitle}</SuccessSubtitle>
        </>
    );
};
